import React from 'react';
import { Modal, Avatar, Tag, Divider, Row, Col, Flex } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { formatDate, formatNumber } from '@/utils/formatters';

export default function PopupViewBox({ dataDetail, setIsShowPopupDetail }) {
  const hideIsdnWin = +dataDetail?.box_type === 2 && +dataDetail?.type === 2;

  return (
    <Modal
      title={`Detail Box (id: ${dataDetail.id})`}
      open={true}
      onCancel={() => setIsShowPopupDetail(false)}
      footer={null}
      width={650}
      centered
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <div className="detail-item">
            <span className="label">Milestone: </span>
            <span className="value" style={{ fontWeight: 600 }}>
              {dataDetail.milestone ? formatNumber(dataDetail.milestone) : "-"}
            </span>
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Type: </span>
            <span className="value" style={{ fontWeight: 600 }}>
              {dataDetail.type == 1 ? 'Heart' : 'Money'}
            </span>
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Mode: </span>
            {dataDetail.mode == 1 ? (
              <Tag color="green">Random trong khoảng min-max</Tag>
            ) : dataDetail.mode == 2 ? (
              <Tag color="blue">Random chọn min hoặc max</Tag>
            ) : dataDetail.mode == 3 ? (
              <Tag color="yellow">Chọn max</Tag>
            ) : (
              <></>
            )}
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Award Min: </span>
            <span className="value" style={{ fontWeight: 600 }}>
              {dataDetail.min ? formatNumber(dataDetail.min || 0) : "-"}
            </span>
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Award Max: </span>
            <span className="value" style={{ fontWeight: 600 }}>
              {dataDetail.max ? formatNumber(dataDetail.max) : "-"}
            </span>
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Rate: </span>
            <span className="value" style={{ fontWeight: 600 }}>
              {dataDetail.rate || 0}
            </span>
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Total Key: </span>
            <span className="value" style={{ fontWeight: 600 }}>
              {dataDetail.total_key || 0}
            </span>
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Description: </span>
            <span className="value" style={{ fontWeight: 600 }}>
              {dataDetail.description || ''}
            </span>
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Is Active: </span>
            {/* <span className="value">{dataDetail.max || 0}</span> */}
            <Tag color={dataDetail.is_active == 1 ? 'green' : 'red'}>
              {dataDetail.is_active == 1 ? 'Active' : 'Inactive'}
            </Tag>
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Created At: </span>
            <span className="value" style={{ fontWeight: 600 }}>
              {formatDate(dataDetail.create_at) || ''}
            </span>
          </div>
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Box type: </span>
            <span className="value" style={{ fontWeight: 600 }}>
              {dataDetail.box_type == 1 ? 'Normal Box' : 'Monthly Box'}
            </span>
          </div>
        </Col>

        <Col span={12}>
          {hideIsdnWin &&
            <div className="detail-item">
              <span className="label">Total Winner: <span className="value" style={{ fontWeight: 600 }}>{dataDetail.total_winner}</span></span>
            </div>
          }
        </Col>

        <Col span={12}>
          <div className="detail-item">
            <span className="label">Special Month: </span>
            <Tag color={dataDetail.is_special_month == 1 ? 'green' : 'red'}>
              {dataDetail.is_special_month == 1 ? 'Yes' : 'No'}
            </Tag>
          </div>
        </Col>
      </Row>
    </Modal>
  );
}
